const ValidationError = require('./errors/ValidationError');
const success = require('./success');
const { errors, regexes } = require('@transfeeradev/api-enums');
const { PersonTypeService, PixKeyValidationService, TransferPixService } = require('@transfeeradev/api-services');

class DestinationBankAccount {
  constructor(data) {
    this._transfer = Object.assign({}, data.transfer);
    this._config = this._config(data);
  }

  validate() {
    const dba =
      this._transfer.destinationBankAccount ||
      this._transfer.destination_bank_account ||
      this._transfer.DestinationBankAccount;
    const isPixDba = TransferPixService.isPix(dba);

    if (dba && dba.email && !regexes.EMAIL.test(dba.email)) {
      return new ValidationError(errors.ptBr.dba.INVALID_EMAIL);
    } else if (this._transfer.emv) {
      return success;
    }

    if (isPixDba) {
      if (dba.pix_key_type && !PixKeyValidationService.isValidKeyType(dba.pix_key_type)) {
        return new ValidationError(errors.ptBr.dba.INVALID_PIX_KEY_TYPE);
      }

      if (dba.pix_key_type && dba.pix_key && !PixKeyValidationService.isValid(dba.pix_key_type, dba.pix_key)) {
        return new ValidationError({
          ...errors.ptBr.dba.INVALID_PIX_KEY,
          data: {
            pix_key_type: dba.pix_key_type
          }
        });
      }
    } else {
      if (this._config.validateDBAName && (!dba.name || !regexes.FIRST_NAME.test(dba.name))) {
        return new ValidationError(errors.ptBr.dba.INVALID_NAME);
      }

      if (
        (dba.cpf_cnpj && !regexes.CPF_CNPJ.test(dba.cpf_cnpj)) ||
        (dba.cpf_cnpj && PersonTypeService.isCPF(dba.cpf_cnpj) && !PersonTypeService.isValidCPF(dba.cpf_cnpj)) ||
        (dba.cpf_cnpj && PersonTypeService.isCNPJ(dba.cpf_cnpj) && !PersonTypeService.isValidCNPJ(dba.cpf_cnpj))
      ) {
        return new ValidationError(errors.ptBr.dba.INVALID_DOCUMENT);
      }
    }

    return success;
  }

  _config(data) {
    const config = {
      validateDBAName: true
    };

    if (!data.config) {
      return config;
    }

    if (typeof data.config !== 'object') {
      return new Error('config need to be an object');
    }

    return Object.assign(config, data.config);
  }
}

module.exports = DestinationBankAccount;
